import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0c8eb7d0 from 'nuxt_plugin_plugin_0c8eb7d0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_portalvue_2f63a5cd from 'nuxt_plugin_portalvue_2f63a5cd' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_dayjsplugin_a5d5c852 from 'nuxt_plugin_dayjsplugin_a5d5c852' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_apollomodule_77b2e812 from 'nuxt_plugin_apollomodule_77b2e812' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_aaba817e from 'nuxt_plugin_image_aaba817e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_auth_16b58796 from 'nuxt_plugin_auth_16b58796' // Source: ../plugins/auth.js (mode: 'client')
import nuxt_plugin_eventbus_7820ebba from 'nuxt_plugin_eventbus_7820ebba' // Source: ../plugins/event-bus.js (mode: 'client')
import nuxt_plugin_axiosconfig_459de025 from 'nuxt_plugin_axiosconfig_459de025' // Source: ../plugins/axios-config.js (mode: 'all')
import nuxt_plugin_globaldirectives_6c93b83c from 'nuxt_plugin_globaldirectives_6c93b83c' // Source: ../plugins/global-directives.js (mode: 'client')
import nuxt_plugin_globalmixins_6a4a62d8 from 'nuxt_plugin_globalmixins_6a4a62d8' // Source: ../plugins/global-mixins.js (mode: 'all')
import nuxt_plugin_persistedstate_48c5b78e from 'nuxt_plugin_persistedstate_48c5b78e' // Source: ../plugins/persisted-state.js (mode: 'client')
import nuxt_plugin_subscriptionpricing_6028e968 from 'nuxt_plugin_subscriptionpricing_6028e968' // Source: ../plugins/subscription-pricing.js (mode: 'client')
import nuxt_plugin_vuelazycomponent_609d4513 from 'nuxt_plugin_vuelazycomponent_609d4513' // Source: ../plugins/vue-lazy-component.js (mode: 'client')
import nuxt_plugin_vueselect_c76d2a0a from 'nuxt_plugin_vueselect_c76d2a0a' // Source: ../plugins/vue-select.js (mode: 'all')
import nuxt_plugin_vuelidate_6e4e74bf from 'nuxt_plugin_vuelidate_6e4e74bf' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_vuebuefy_b89fecdc from 'nuxt_plugin_vuebuefy_b89fecdc' // Source: ../plugins/vue-buefy.js (mode: 'all')
import nuxt_plugin_jsonld_a98917c4 from 'nuxt_plugin_jsonld_a98917c4' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_gtm_0ae683b0 from 'nuxt_plugin_gtm_0ae683b0' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_googleads_f6912f3c from 'nuxt_plugin_googleads_f6912f3c' // Source: ../plugins/google-ads.js (mode: 'client')
import nuxt_plugin_meta_b5aab5ac from 'nuxt_plugin_meta_b5aab5ac' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Telecompaper","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, minimum-scale=1.0"},{"hid":"description","name":"description","content":"Telecompaper - Telecom news and research"},{"name":"format-detection","content":"telephone=no"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"apple-mobile-web-app-title","content":"Telecompaper"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"search","type":"application\u002Fopensearchdescription+xml","title":"Telecompaper","href":"\u002Fsearch\u002Fopen-search.xml"},{"rel":"apple-touch-icon","href":"\u002Fimages\u002Ftouch_icon.png"},{"rel":"preconnect","href":"https:\u002F\u002Ftelecompaper-api-abduz5l4ya-ez.a.run.app"},{"rel":"preconnect","href":"https:\u002F\u002Fik.imagekit.io"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c8eb7d0 === 'function') {
    await nuxt_plugin_plugin_0c8eb7d0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2f63a5cd === 'function') {
    await nuxt_plugin_portalvue_2f63a5cd(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_a5d5c852 === 'function') {
    await nuxt_plugin_dayjsplugin_a5d5c852(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_77b2e812 === 'function') {
    await nuxt_plugin_apollomodule_77b2e812(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_image_aaba817e === 'function') {
    await nuxt_plugin_image_aaba817e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_16b58796 === 'function') {
    await nuxt_plugin_auth_16b58796(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventbus_7820ebba === 'function') {
    await nuxt_plugin_eventbus_7820ebba(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosconfig_459de025 === 'function') {
    await nuxt_plugin_axiosconfig_459de025(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globaldirectives_6c93b83c === 'function') {
    await nuxt_plugin_globaldirectives_6c93b83c(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmixins_6a4a62d8 === 'function') {
    await nuxt_plugin_globalmixins_6a4a62d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedstate_48c5b78e === 'function') {
    await nuxt_plugin_persistedstate_48c5b78e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_subscriptionpricing_6028e968 === 'function') {
    await nuxt_plugin_subscriptionpricing_6028e968(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazycomponent_609d4513 === 'function') {
    await nuxt_plugin_vuelazycomponent_609d4513(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselect_c76d2a0a === 'function') {
    await nuxt_plugin_vueselect_c76d2a0a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_6e4e74bf === 'function') {
    await nuxt_plugin_vuelidate_6e4e74bf(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebuefy_b89fecdc === 'function') {
    await nuxt_plugin_vuebuefy_b89fecdc(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_a98917c4 === 'function') {
    await nuxt_plugin_jsonld_a98917c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_0ae683b0 === 'function') {
    await nuxt_plugin_gtm_0ae683b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleads_f6912f3c === 'function') {
    await nuxt_plugin_googleads_f6912f3c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b5aab5ac === 'function') {
    await nuxt_plugin_meta_b5aab5ac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
